export default {
    labels: {
        title: 'Análise do documento: ',
        subtitle: 'Foram encontradas divergências. Veja abaixo os campos a revisar.',
        valueNotFound: 'Não encontrado',
        confidencePercentage: 'Confiança',
        denialRisk: 'Risco de glosa: ',
        howToFix: 'Como corrigir: ',
    },
    grid: {
        columns: {
            field: 'Campo',
            valueReadedByAi: 'O que foi lido no documento',
            reason: 'Motivos de reprovação',
            status: 'Status'
        }
    },
    actions: {
        replaceDocument: 'Substituir documento',
        cancel: 'Cancelar'
    },
    errorReasons: {
        requiredFieldNotProvided: {
            reason: 'Este campo no documento é obrigatório e não está preenchido',
            howToFix: 'Preencha seguindo os padrões exigidos para este tipo de documento'
        },
        incorrectValue: {
            reason: 'Este campo não está em conformidade com o padrão da ANS.',
            howToFix: 'Preencha seguindo os padrões exigidos para este tipo de documento.'
        },
        conflictValues: [
            {
                subreasonKey: 'Value Differs from Osigu Input',
                reason: 'Este campo no documento está divergente das informações registradas no sistema',
                howToFix: 'Verifique em seu sistema o preenchimento do campo {field}'
            },
            {
                subreasonKey: 'Inconsistency detected in doctor´s name',
                reason: 'Este campo foi preenchido como {value}, porém esse nome não corresponde ao profissional associado ao CRM informado.',
                howToFix: 'Corrija este campo e atualize com o nome completo conforme o registro no conselho.'
            },
            {
                subreasonKey: 'Doctor has an inactive CRM status',
                reason: 'Este campo foi preenchido com o número {value}, porém esse CRM encontra-se inativo no conselho profissional.',
                howToFix: 'Substitua pelo registro de um profissional ativo e atualize também o nome correspondente no campo 15.'
            },
            {
                subreasonKey: 'Invalid Procedure Code',
                reason: 'Este campo foi preenchido com o código {value}, porém está inativo na tabela TUSS vigente',
                howToFix: 'Verifique a versão mais recente da tabela TUSS disponibilizada pela ANS e substitua por um código ativo e correspondente ao procedimento solicitado.'
            },
            {
                subreasonKey: 'Procedure code does not match procedure description',
                reason: 'Este campo foi preenchido com o código {value}, porém não corresponde à descrição do procedimento informada no documento.',
                howToFix: 'Substitua pelo código TUSS correspondente à descrição correta.'
            }
        ],
        documentNotMatched: {
            reason: 'O arquivo enviado não parece ser uma Guia TISS válida.',
            howToFix: 'Verifique se o documento anexado corresponde a uma Guia TISS'
        }
    }
}